import _ from 'lodash';
import { ReportDataProvider } from './ReportDataProvider';
import { tableColumnSettings } from './reportTableColumnSettings';
import { Metrics, ReportDimension, ReportRecord } from 'core/report/ReportData';
import { divideValue } from './ReportDataHelper';
import { hasRoles } from 'core/permission/PermissionDSL';
import { RoleNames, Actor } from 'core';

enum COLUMNS {
  NAME = 'name',
  IMPRES = 'impres',
  CLICKS = 'clicks',
  CTR = 'ctr',
  CPM = 'cpm',
  CPC = 'cpc',
  MEDIA_COST = 'mediaCost',
  MEDIA_SPENT = 'mediaSpent',
  SPENT = 'spent',
  EDITBTNS = 'editBtns',
}

export class GeneralReportDataProvider implements ReportDataProvider {
  onDimensionNameClick: any;
  onDateClick: any;
  onEditClick: any;
  constructor(onDimensionNameClick, onDateClick, onEditClick) {
    this.onDimensionNameClick = onDimensionNameClick;
    this.onDateClick = onDateClick;
    this.onEditClick = onEditClick;
  }

  get avalableDimensions() {
    return [
      ReportDimension.DAY,
      ReportDimension.AGENCY,
      ReportDimension.ADVERTISER,
      ReportDimension.ORDER,
      ReportDimension.L2_CHANNEL,
      ReportDimension.CAMPAIGN_TYPE,
      ReportDimension.CREATIVE,
      ReportDimension.CREATIVE_TYPE,
      ReportDimension.PRODUCT,
      ReportDimension.SEARCH_KEYWORD,
    ];
  }

  getReportDimensions(actor: Actor | null): Array<ReportDimension> {
    const isSysAdmin = hasRoles(RoleNames.sysAdmin).visible({ actor });
    const isAdvertiser = hasRoles(
      RoleNames.adsAdmin,
      RoleNames.adsReport,
      RoleNames.adsSales,
    ).visible({ actor });
    const forbidDimensions = [ReportDimension.MONTH, ReportDimension.HOUR];
    !isSysAdmin && forbidDimensions.push(ReportDimension.AGENCY);
    isAdvertiser && forbidDimensions.push(ReportDimension.ADVERTISER);
    return this.avalableDimensions.filter(
      (dimension) => forbidDimensions.indexOf(dimension) === -1,
    );
  }

  getReportTableColumnSettings(
    allowMetrics: Array<Metrics>,
    tableData: any,
    dimension: ReportDimension,
    currency: string,
  ) {
    const allColumnSettings = tableColumnSettings(
      tableData,
      dimension,
      currency,
      this.onDimensionNameClick,
      this.onDateClick,
    );
    const tableAllowMetrics = [...allowMetrics, COLUMNS.NAME, COLUMNS.EDITBTNS];
    if (tableAllowMetrics.indexOf(Metrics.SPENT) !== -1) {
      tableAllowMetrics.indexOf(Metrics.IMPRES) !== -1 &&
        tableAllowMetrics.push(COLUMNS.CPM);
      tableAllowMetrics.indexOf(Metrics.CLICKS) !== -1 &&
        tableAllowMetrics.push(COLUMNS.CPC);
    }
    if (tableAllowMetrics.indexOf(Metrics.CLICKS) !== -1) {
      tableAllowMetrics.indexOf(Metrics.IMPRES) !== -1 &&
        tableAllowMetrics.push(COLUMNS.CTR);
    }
    return _.compact(
      Object.values(COLUMNS).map((column) => {
        return (
          tableAllowMetrics.indexOf(column) !== -1 && allColumnSettings[column]
        );
      }),
    );
  }

  getReportTableData(records: Array<ReportRecord>) {
    return records.map((record) => {
      return {
        key: record.dimensionName + _.get(record, 'dimensionID', 0),
        id: _.get(record, 'dimensionID', 0).toString(),
        parentId: record.parentId,
        extra: record.extra,
        [COLUMNS.NAME]: record.dimensionName,
        [COLUMNS.IMPRES]: record.impres,
        [COLUMNS.CLICKS]: record.clicks,
        [COLUMNS.CTR]: divideValue(
          _.get(record, 'clicks', 0) * 100,
          _.get(record, 'impres', 0),
        ),
        [COLUMNS.CPM]: divideValue(
          _.floor(_.get(record, 'spent', 0), 2) * 1000,
          _.get(record, 'impres', 0),
        ),
        [COLUMNS.CPC]: divideValue(
          _.floor(_.get(record, 'spent', 0), 2),
          _.get(record, 'clicks', 0),
        ),
        [COLUMNS.MEDIA_COST]: _.get(record, 'mediaCost', 0),
        [COLUMNS.MEDIA_SPENT]: _.get(record, 'mediaSpent', 0),
        [COLUMNS.SPENT]: _.floor(_.get(record, 'spent', 0), 2),
      };
    });
  }
}
